import './Program_table.css';

const ProgramTable = () => {
  return (
    <table className="program-table">
      <tbody>
        <tr>
          <th>Date</th>
          <th>Time</th>
          <th>Events</th>
          <th>Location</th>
        </tr>
        <tr>
          <td rowSpan="2">July 17th</td>
          <td>13:00-18:00</td>
          <td>Registration</td>
          <td>-</td>
        </tr>
        <tr>
          <td>18:00-19:30</td>
          <td>Welcome Cocktail/Dinner Party</td>
          <td>-</td>
        </tr>
        <tr>
          <td rowSpan="4">July 18th</td>
          <td>08:30-12:30</td>
          <td>Opening Ceremony, Plenary talks</td>
          <td>Multi-function Hall</td>
        </tr>
        <tr>
          <td>12:30-13:00</td>
          <td>Lunch</td>
          <td>Cafe Hall</td>
        </tr>
        <tr>
          <td>13:00-18:00</td>
          <td className="events-multi">
            Parallel Onsite Sessions (Meeting Room 1#)<br />
            Parallel Onsite Sessions (Meeting Room 2#)<br />
            Parallel Online Sessions (Zoom No.1#)<br />
            Parallel Online Sessions (Zoom No.2#)
          </td>
          <td className="events-multi">
            Meeting Room 1#<br />
            Meeting Room 2#<br />
            Zoom No.1#<br />
            Zoom No.2#
          </td>
        </tr>
        <tr>
          <td>18:30-</td>
          <td>Banquet</td>
          <td>Banquet Hall</td>
        </tr>
        <tr>
          <td>July 19th-20th</td>
          <td>-</td>
          <td>Social Activities after technical sessions</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ProgramTable;
